import { connect } from "react-redux";
import { getBets, getCurrentUserId, getExpandedRace, getPayouts, getRaceEntrants, getTicketScores, getTokenTypes, getUsers } from "../selectors";
import LeaderboardItem from "../components/leaderboard-item";

function select(state, props) {
  return {
    bets: getBets(state, props),
    currentUserId: getCurrentUserId(state, props),
    expandedRace: getExpandedRace(state, props),
    payouts: getPayouts(state, props),
    raceEntrants: getRaceEntrants(state, props),
    ticketScores: getTicketScores(state, props),
    tokenTypes: getTokenTypes(state, props),
    users: getUsers(state, props),
  };
}

export default connect(select)(LeaderboardItem);
